import { CustomError } from './custom-error';
import { CodeError } from '../constant/text.constant';

export class UserNotFoundError extends CustomError {
  private static readonly CODE = CodeError.USER_NOT_FOUND;

  constructor() {
    super(UserNotFoundError.CODE);
  }
}
